// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"74577c94","977":"7f5d714c"}[chunkId] + ".chunk.js";
};